import { UserProfile } from '__generated__/GQL';
import { computeModuleStatusFromSubStatuses } from 'features/Onboarding/lib/computeModuleStatusFromSubStatuses';
import { ApplicantType } from 'features/Onboarding/types';

import getComplianceStatus from '../../Compliance/libs/getComplianceStatus';
import { default as getPersonalAddressStatus } from '../../PersonalAddress/lib/getModuleStatus';

const getComplianceAndPersonalAddressStatus = ({
  applicantType,
  userProfile,
}: {
  userProfile: Pick<
    UserProfile,
    | 'street'
    | 'zip'
    | 'city'
    | 'country'
    | 'isComplianceFilled'
    | 'isEligibleToOnboard'
  >;
  applicantType: ApplicantType;
}) => {
  const complianceStatus = getComplianceStatus({
    applicantType,
    userProfile,
  });
  const personalAddressStatus = getPersonalAddressStatus({
    applicantType,
    userProfile,
  });

  return computeModuleStatusFromSubStatuses([
    complianceStatus,
    personalAddressStatus,
  ]);
};

export default getComplianceAndPersonalAddressStatus;
